angular.module('core')
  .service('edxCustomerResourcesService', [
    function() {

      var SUPPORT_URL = 'https://support.dreambox.com';

      var self = this;

      var adminFtueArticles = [
          {
              title: 'Back to School 2017: Administrator Guide',
              url: 'https://support.dreambox.com/s/article/Back-to-School-2017-Administrator-Guide'
          },
          {
              title: 'Administrator Reporting: Growth Percentages',
              url: 'https://support.dreambox.com/s/article/Administrator-Reporting-Growth-Percentages'
          },
          {
              title: 'Preparing iPads to Run DreamBox: Tips for Schools',
              url: 'https://support.dreambox.com/s/article/Preparing-iPads-to-Run-DreamBox--Tips-for-Schools'
          },
          {
              title: 'How does DreamBox work?',
              url: 'https://support.dreambox.com/s/article/How-Does-DreamBox-Work'
          },
          {
              title: 'Downloading or Updating the DreamBox Math iPad App',
              url: 'https://support.dreambox.com/s/article/Downloading-or-Updating-the-DreamBox-Math-iPad-App'
          },
          {
              title: 'K-2 Learning Environment',
              url: 'https://support.dreambox.com/s/article/The-Grades-K-2-Learning-Environment'
          },
          {
              title: '3-5 Learning Environment',
              url: 'https://support.dreambox.com/s/article/The-Grades-3-5-Learning-Environment'
          },
          {
              title: '6-8 Learning Environment',
              url: 'https://support.dreambox.com/s/article/The-Grades-6-8-Learning-Environment'
          }
      ];

      var guardianFtueArticles = [];

      var teacherFtueArticles = [
          {
              title: 'Getting Students Started with DreamBox',
              url: 'https://support.dreambox.com/s/article/Getting-Students-Started-with-DreamBox'
          },
          {
              title: 'Insight Dashboard Overview',
              url: 'https://support.dreambox.com/s/article/Insight-Dashboard-Overview'
          },
          {
              title: 'Insight Dashboard Reporting - Classroom Level Reports',
              url: 'https://support.dreambox.com/s/article/Insight-Dashboard-Reporting---Classroom-Level-Reports'
          },
          {
              title: 'Insight Dashboard Reporting - Student Level Reports',
              url: 'https://support.dreambox.com/s/article/Insight-Dashboard-Reporting---Student-Level-Reports'
          },
          {
              title: 'Recommended Usage for Students',
              url: 'https://support.dreambox.com/s/article/Recommended-Usage-for-Students'
          },
          {
              title: 'How Can I See if a Student is Struggling?',
              url: 'https://support.dreambox.com/s/article/How-Can-I-See-If-a-Student-Is-Struggling'
          },
          {
              title: 'Edit Student Details (Names, Usernames, Grade Levels, Passwords, Language)',
              url: 'https://support.dreambox.com/s/article/Edit-Student-Details-Names-Username-Grade-Level-Passwords-Language'
          },
          {
              title: 'Assignments - How to Create Assignments',
              url: 'https://support.dreambox.com/s/article/AssignFocus-How-to-Create-Assignments-School-Teachers-and-Administrators'
          }
      ];

      var _getFtueArticles = function (customer) {
        if (customer.isAdmin()) {
          return adminFtueArticles;
        } else if (customer.isGuardian() ) {
          return guardianFtueArticles;
        } else {
          return teacherFtueArticles;
        }
      };

      self.getFtueSupportArticles = function (customer) {
        return _getFtueArticles(customer);
      };

      self.getSupportUrl = function () {
        return SUPPORT_URL;
      };

      self.getAvatarType = function (customer) {
        if (customer.isDistrictAdmin()) {
          return 'district';
        } else if (customer.isSchoolAdmin()) {
          return 'school';
        } else if (customer.isTeacher()) {
          return 'teacher';
        } else if (customer.isGuardian()) {
          return 'guardian';
        }
      };
  }]);
